import Constants from '../../data/constants'
import * as types from '../types';

const state = {
    appState: Constants.appState.AppState_NONE,
};

const getters = {
    [types.GET_APP_STATE]: state => {
        return state.appState;
    },
};

const mutations = {
    [types.SET_APP_STATE]: (state, payload) => {      
        state.appState = payload;
    },
};

const actions = {

};

export default {
    state,
    getters,
    mutations,
    actions,
}